var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83333 9.20842C3.22453 9.20842 3.54167 9.52555 3.54167 9.91675V14.8751C3.54167 15.2663 3.22453 15.5834 2.83333 15.5834C2.44213 15.5834 2.125 15.2663 2.125 14.8751V9.91675C2.125 9.52555 2.44213 9.20842 2.83333 9.20842Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83333 1.41675C3.22453 1.41675 3.54167 1.73388 3.54167 2.12508V7.08342C3.54167 7.47462 3.22453 7.79175 2.83333 7.79175C2.44213 7.79175 2.125 7.47462 2.125 7.08342V2.12508C2.125 1.73388 2.44213 1.41675 2.83333 1.41675Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 7.79175C8.8912 7.79175 9.20833 8.10888 9.20833 8.50008V14.8751C9.20833 15.2663 8.8912 15.5834 8.5 15.5834C8.1088 15.5834 7.79167 15.2663 7.79167 14.8751V8.50008C7.79167 8.10888 8.1088 7.79175 8.5 7.79175Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 1.41675C8.8912 1.41675 9.20833 1.73388 9.20833 2.12508V5.66675C9.20833 6.05795 8.8912 6.37508 8.5 6.37508C8.1088 6.37508 7.79167 6.05795 7.79167 5.66675V2.12508C7.79167 1.73388 8.1088 1.41675 8.5 1.41675Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 10.6251C14.5579 10.6251 14.875 10.9422 14.875 11.3334V14.8751C14.875 15.2663 14.5579 15.5834 14.1667 15.5834C13.7755 15.5834 13.4583 15.2663 13.4583 14.8751V11.3334C13.4583 10.9422 13.7755 10.6251 14.1667 10.6251Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 1.41675C14.5579 1.41675 14.875 1.73388 14.875 2.12508V8.50008C14.875 8.89128 14.5579 9.20842 14.1667 9.20842C13.7755 9.20842 13.4583 8.89128 13.4583 8.50008V2.12508C13.4583 1.73388 13.7755 1.41675 14.1667 1.41675Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.91675C0 9.52555 0.317132 9.20842 0.708333 9.20842H4.95833C5.34953 9.20842 5.66667 9.52555 5.66667 9.91675C5.66667 10.308 5.34953 10.6251 4.95833 10.6251H0.708333C0.317132 10.6251 0 10.308 0 9.91675Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66667 5.66675C5.66667 5.27555 5.9838 4.95842 6.375 4.95842H10.625C11.0162 4.95842 11.3333 5.27555 11.3333 5.66675C11.3333 6.05795 11.0162 6.37508 10.625 6.37508H6.375C5.9838 6.37508 5.66667 6.05795 5.66667 5.66675Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 11.3334C11.3333 10.9422 11.6505 10.6251 12.0417 10.6251H16.2917C16.6829 10.6251 17 10.9422 17 11.3334C17 11.7246 16.6829 12.0417 16.2917 12.0417H12.0417C11.6505 12.0417 11.3333 11.7246 11.3333 11.3334Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/sliders.a65fbefcdb609a66fb8eb422a74e4400.svg";
export { ForwardRef as ReactComponent };